export const darkTheme = {
  colors: {
    bg:    '#141414',
    s1:    '#1C1C1C',
    s2:    '#222222',
    s3:    '#2A2A2A',
    s4:    '#313131',
    b1:    '#2E2E2E',
    b2:    '#3A3A3A',
    accent:    '#B84242',
    accentHi:  '#CC5555',
    accentLo:  'rgba(184,66,66,.09)',
    accentDim: 'rgba(184,66,66,.2)',
    red:      '#B84242',
    redHi:    '#CC5555',
    redLo:    'rgba(184,66,66,.09)',
    redDim:   'rgba(184,66,66,.2)',
    redDark:  '#923030',
    green:    '#4F9B6F',
    greenHi:  '#63B887',
    greenLo:  'rgba(79,155,111,.1)',
    blue:     '#4878B0',
    blueHi:   '#6090C8',
    blueLo:   'rgba(72,120,176,.1)',
    amber:    '#A07C30',
    amberHi:  '#C09848',
    amberLo:  'rgba(160,124,48,.1)',
    purple:   '#6E62A8',
    purpleHi: '#8878C0',
    purpleLo: 'rgba(110,98,168,.1)',
    t1: '#E8E8E8',
    t2: '#A0A0A0',
    t3: '#686868',
    t4: '#424242',
  },
  radius: {
    sm:   '6px',
    md:   '10px',
    lg:   '12px',
    xl:   '16px',
    full: '9999px',
  },
  spacing: {
    1: '4px',  2: '8px',  3: '12px',
    4: '16px', 5: '20px', 6: '24px',
  },
  font: {
    xs:   '10px',
    sm:   '11.5px',
    base: '13px',
    md:   '14px',
    lg:   '16px',
    xl:   '20px',
    '2xl': '24px',
    '3xl': '30px',
  },
  shadow: {
    sm: '0 2px 8px rgba(0,0,0,.2)',
    md: '0 4px 16px rgba(0,0,0,.3)',
    lg: '0 8px 32px rgba(0,0,0,.4)',
    xl: '0 24px 64px rgba(0,0,0,.5)',
  },
};

export const lightTheme = {
  colors: {
    bg:    '#F4F4F5',
    s1:    '#FFFFFF',
    s2:    '#F9F9FA',
    s3:    '#F0F0F2',
    s4:    '#E8E8EB',
    b1:    '#E2E2E6',
    b2:    '#D4D4DA',
    accent:    '#C04040',
    accentHi:  '#D05050',
    accentLo:  'rgba(192,64,64,.08)',
    accentDim: 'rgba(192,64,64,.15)',
    red:      '#C04040',
    redHi:    '#D05050',
    redLo:    'rgba(192,64,64,.08)',
    redDim:   'rgba(192,64,64,.15)',
    redDark:  '#A03030',
    green:    '#3A8A5E',
    greenHi:  '#4AA070',
    greenLo:  'rgba(58,138,94,.08)',
    blue:     '#3A68A0',
    blueHi:   '#5080B8',
    blueLo:   'rgba(58,104,160,.08)',
    amber:    '#906820',
    amberHi:  '#B08030',
    amberLo:  'rgba(144,104,32,.08)',
    purple:   '#5E52A0',
    purpleHi: '#7868B8',
    purpleLo: 'rgba(94,82,160,.08)',
    t1: '#1A1A1A',
    t2: '#4A4A4A',
    t3: '#7A7A7A',
    t4: '#AAAAAA',
  },
  radius:  { ...darkTheme.radius  },
  spacing: { ...darkTheme.spacing },
  font:    { ...darkTheme.font    },
  shadow: {
    sm: '0 2px 8px rgba(0,0,0,.06)',
    md: '0 4px 16px rgba(0,0,0,.08)',
    lg: '0 8px 32px rgba(0,0,0,.1)',
    xl: '0 24px 64px rgba(0,0,0,.12)',
  },
};

export const themes = { dark: darkTheme, light: lightTheme };
export default darkTheme;
